import React from "react";

import ResultList from "../results/ResultList";

function ResultsPage() {
  return <ResultList />;
}

export default ResultsPage;
